import { SvgIcon, SvgIconProps } from "@mui/material";

export function PendingEvaluationIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 26">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M17.558 0C17.8 0 18 .202 18 .449v2.116c0 .246-.2.449-.442.449h-.531v3.944c0 1.915-1.115 2.705-1.59 3.042-.218.155-1.267.805-2.326 1.458l-.423.26-1.603.98v1.154l4.369 2.705c1.004.621 1.573 1.065 1.573 2.961v3.468h.53c.244 0 .443.202.443.45v2.115a.447.447 0 0 1-.442.449H.442A.447.447 0 0 1 0 25.551v-2.116c0-.247.199-.449.442-.449h.531V19.59c0-1.915 1.114-2.705 1.59-3.042.377-.267 3.251-2.027 4.352-2.699v-1.153l-4.37-2.704C1.542 9.37.974 8.926.974 7.03V3.014H.442A.447.447 0 0 1 0 2.564V.45C0 .202.199 0 .442 0zm-2.122 3.014H2.564V7.03c0 .557.052.913.16 1.086.09.145.285.27.65.495l4.75 2.94a.81.81 0 0 1 .381.69v2.065A.811.811 0 0 1 8.12 15c-1.704 1.039-4.346 2.662-4.646 2.874-.384.272-.91.645-.91 1.717v3.396h12.872v-3.468c0-.557-.053-.913-.16-1.086-.09-.145-.285-.27-.65-.495l-4.75-2.94a.812.812 0 0 1-.382-.69v-2.065a.81.81 0 0 1 .386-.693c1.703-1.039 4.346-2.661 4.646-2.874.384-.272.91-.645.91-1.717V3.014zM8.979 16.46c1.496 0 4.894 2.724 5.659 3.304.107.082.167.138.167.334v2.098c.001.039-.007.195-.204.195h-.053l-.938.001h-.165l-.754.001h-.883l-.238.001h-.49l-.253.001h-.778l-.265.001h-.536l-.269.001h-.805l-.265-.001-.778-.001h-.743l-.238-.001h-.673l-.21-.001h-.754l-.165-.001-.938-.001h-.053c-.17 0-.2-.115-.204-.172v-2.121c0-.196.059-.252.167-.334.764-.58 4.163-3.304 5.659-3.304z"
      />
    </SvgIcon>
  );
}
export function ReadingDomainIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21">
      <path
        fill="#585858"
        fillRule="nonzero"
        d="M26.103 3.5c.538 0 .976.439.976.978v15.544a.973.973 0 0 1-1.194.953c-2.337-.534-6.439-1.155-10.329-.2 2.25-2.134 5.426-2.512 7.352-2.516a2.5 2.5 0 0 0 2.488-2.497V3.5zm-24.42 0v12.263a2.5 2.5 0 0 0 2.488 2.496c1.926.005 5.103.382 7.352 2.516-3.89-.955-7.992-.334-10.33.2A.973.973 0 0 1 0 20.022h.001V4.478c0-.54.438-.978.976-.978h.707zM3.866 0c2.303.005 6.493.533 8.674 4.007a.929.929 0 0 1 .135.495v15.331c-2.656-2.75-6.507-3.224-8.806-3.23a.986.986 0 0 1-.988-.976V.977A.979.979 0 0 1 3.863 0zm19.35 0a.979.979 0 0 1 .982.977v14.65a.986.986 0 0 1-.988.976c-2.299.006-6.15.48-8.806 3.23V4.503c0-.183.047-.354.135-.496C16.72.533 20.91.005 23.213 0z"
      />
    </SvgIcon>
  );
}
export function WritingDomainIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
      <path
        fill="#585858"
        fillRule="nonzero"
        d="M14.164 18.007c.404 0 .696.468.478.82a23.05 23.05 0 0 1-.25.394.344.344 0 0 0 .335.526l5.646-.726a.655.655 0 0 1 .094-.007c.255 0 .458.15.517.381.037.142.007.299-.075.427a.47.47 0 0 1-.322.212h-.005l-7.613.964a.472.472 0 0 1-.388-.144c-.184-.185-.221-.543-.063-.758.058-.078.115-.158.173-.235a.343.343 0 0 0-.331-.54L3.54 20.64a.493.493 0 0 1-.453-.153.542.542 0 0 1-.14-.326.502.502 0 0 1 .434-.548l2.413-.36.885-.133 7.4-1.105a.556.556 0 0 1 .085-.007zM.936 15.386l3.661 2.913c-.186.1-.352.169-.35.169l-3.736 1.69a.36.36 0 0 1-.503-.4l.839-3.99s.03-.179.09-.382zm10.358-13.09l3.883 3.094-.002.003.712.566.416-.516a.757.757 0 0 1 1.037-.14c.333.252.39.724.13 1.046l-4.262 5.297a.744.744 0 0 1-1.315-.379.727.727 0 0 1 .159-.541l2.914-3.619-.713-.566-9.01 11.187-3.886-3.091 9.937-12.34zM12.4.92a2.474 2.474 0 0 1 3.463-.383l.04.031a2.436 2.436 0 0 1 .386 3.441l-.62.772-3.887-3.092z"
      />
    </SvgIcon>
  );
}
export function ListeningDomainIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 24">
      <g fill="#585858" fillRule="nonzero">
        <path d="M21.828 3.58c3.235.304 5.772 3.234 5.772 6.657 0 2.121-.69 4.21-1.94 5.91l-.213.28-1.85 2.332c-.477.598-.838 1.344-1.07 2.059-.547 1.63-2.06 2.73-3.759 2.73-2.121 0-3.86-1.759-3.963-3.875l-.005-.2v-3.035l.102-.037.279.422a.655.655 0 0 0 .66.144.628.628 0 0 0 .429-.508l1.479-3.602c1.477-.82 2.649-1.868 3.385-3.062.395.32.648.814.648 1.368a1.75 1.75 0 0 1-1.602 1.753l-.144.005v1.173c1.606 0 2.91-1.313 2.91-2.93a2.934 2.934 0 0 0-1.289-2.434 5.322 5.322 0 0 0 .334-1.559c1.22.37 2.118 1.627 2.118 3.066a6.405 6.405 0 0 1-1.21 3.757l-.175.229-2.862 3.61.907.726 2.863-3.598a7.63 7.63 0 0 0 1.64-4.724c0-2.112-1.444-3.93-3.351-4.281-.148-.848-.503-1.656-1.03-2.4.306-.014.619-.007.937.023zm10.975 5.569a7.162 7.162 0 0 1 1.997 5 7.17 7.17 0 0 1-1.787 4.773l-.21.227-.803-.833a5.969 5.969 0 0 0 1.664-4.167c0-1.475-.52-2.868-1.468-3.954L32 9.982l.803-.833zm-1.9 1.6c.965.91 1.497 2.117 1.497 3.4a4.62 4.62 0 0 1-1.31 3.214l-.187.186-.903-.85c.724-.683 1.123-1.588 1.123-2.55 0-.888-.34-1.728-.962-2.388L30 11.599l.903-.85zm-1.63 2c.469.428.727.995.727 1.6 0 .544-.209 1.058-.592 1.468l-.134.132-.874-.801c.234-.213.363-.497.363-.8 0-.258-.095-.503-.27-.702l-.093-.096.874-.801zM16 6.499c0 .59-.34 1.1-.835 1.346a6.455 6.455 0 0 1 .814-1.581c.015.077.021.155.021.235z" />
        <path d="M12.832 13.194l2.155 2.107a.529.529 0 0 0 .898-.313l.395-3.092c2.141-1.237 3.504-3.083 3.504-5.147C19.784 3.02 15.354 0 9.892 0 4.429 0 0 3.021 0 6.749c0 3.725 4.429 6.747 9.892 6.747 1.023 0 2.011-.106 2.94-.302zm.82-7.75a1.304 1.304 0 1 1 .002 2.608 1.304 1.304 0 0 1-.003-2.608zM6.131 8.05a1.305 1.305 0 1 1-.001-2.61 1.305 1.305 0 0 1 0 2.61zm2.456-1.304A1.304 1.304 0 1 1 9.892 8.05a1.303 1.303 0 0 1-1.304-1.304z" />
      </g>
    </SvgIcon>
  );
}
export function LanguageDomainIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 21">
      <path
        fill="#585858"
        fillRule="nonzero"
        d="M25.6 10.5c.273.799.488 1.55.644 2.254.156.704.234 1.436.234 2.197 0 1.75-.478 3.177-1.435 4.28-.957 1.103-2.335 1.655-4.132 1.655-.742 0-1.416-.124-2.021-.371-.606-.247-1.084-.58-1.436-.999-.43.495-.986.866-1.67 1.113a6.411 6.411 0 0 1-2.197.371c-1.915 0-3.292-.476-4.131-1.427-.84-.95-1.26-2.168-1.26-3.652 0-.38.048-.913.146-1.598.098-.684.225-1.274.381-1.769l3.985-.114a12.754 12.754 0 0 0-.235 2.454c0 .685.118 1.189.352 1.512.234.324.586.485 1.055.485.39 0 .693-.114.908-.342.215-.228.38-.647.498-1.256.117-.608.176-1.464.176-2.567l3.809-.229c-.04.761-.059 1.541-.059 2.34 0 1.255.508 1.883 1.524 1.883.547 0 .918-.171 1.113-.513.195-.343.293-.856.293-1.541 0-.495-.059-1.037-.176-1.627-.117-.59-.254-1.15-.41-1.683l4.043-.856zM7.67 0C8.337 0 8.95.167 9.51.501c.56.334 1.007.784 1.34 1.35.332.567.499 1.199.499 1.896 0 1.104-.348 2.07-1.044 2.897-.696.828-1.83 1.561-3.405 2.2-1.573.64-3.661 1.191-6.264 1.656L0 7.799c1.937-.32 3.616-.697 5.038-1.133-.514-.407-.885-.828-1.112-1.264-.227-.435-.34-.973-.34-1.612 0-.61.181-1.205.545-1.786A4.41 4.41 0 0 1 5.606.566 3.895 3.895 0 0 1 7.67 0zM29 1.853V4.94L17.652 6.794V3.747L29 1.853zm-21.601.935c-.273 0-.522.117-.75.349-.226.232-.34.494-.34.784 0 .262.099.501.295.719.197.218.553.472 1.067.762.545-.435.817-.9.817-1.394 0-.32-.106-.602-.318-.85a.981.981 0 0 0-.771-.37z"
      />
    </SvgIcon>
  );
}
export function StudentsGroupIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 29">
      <g fill="#62C3EE" fillRule="nonzero">
        <path d="M31.25 19A4.756 4.756 0 0 1 36 23.75v3.5a.75.75 0 0 1-.75.75h-16.5a.75.75 0 0 1-.75-.75v-3.5A4.756 4.756 0 0 1 22.75 19zM27 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        <path d="M31.25 19A4.756 4.756 0 0 1 36 23.75v3.5a.75.75 0 0 1-.75.75h-16.5a.75.75 0 0 1-.75-.75v-3.5A4.756 4.756 0 0 1 22.75 19zM27 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        <path
          stroke="#FFF"
          d="M17.93 15.929c1.768 0 3.374.705 4.556 1.85a6.607 6.607 0 0 1 2.01 4.519h0l.004 4.738a1.462 1.462 0 0 1-1.32 1.458h0L1.958 28.5a1.464 1.464 0 0 1-1.452-1.326h0L.5 22.536c0-1.777.7-3.392 1.838-4.58a6.535 6.535 0 0 1 4.495-2.023h0zM12.5.5c1.903 0 3.625.776 4.872 2.03A6.927 6.927 0 0 1 19.39 7.43c0 1.913-.77 3.644-2.017 4.898a6.848 6.848 0 0 1-4.872 2.03 6.848 6.848 0 0 1-4.872-2.03A6.927 6.927 0 0 1 5.61 7.429c0-1.913.77-3.645 2.017-4.899A6.848 6.848 0 0 1 12.5.5z"
        />
      </g>
    </SvgIcon>
  );
}
export function SortIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 25">
      <g fill="#62C3EE" fillRule="nonzero">
        <path d="M7.255 23.86l6.19-9.354a.336.336 0 0 0 .02-.333.308.308 0 0 0-.274-.173H.81a.308.308 0 0 0-.275.173.336.336 0 0 0 .02.333l6.19 9.355c.058.087.153.139.255.139a.307.307 0 0 0 .255-.14z" />
        <path
          d="M7.255 1.14l6.19 9.354a.336.336 0 0 1 .02.333.308.308 0 0 1-.274.173H.81a.308.308 0 0 1-.275-.173.336.336 0 0 1 .02-.333l6.19-9.355A.306.306 0 0 1 7 1c.102 0 .197.052.255.14z"
          opacity=".2"
        />
      </g>
    </SvgIcon>
  );
}
export function EvaluationIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 40">
      <path
        fillRule="nonzero"
        d="M29.063 5.258a5.856 5.856 0 0 1 2.03 4.43V34.14c0 3.23-2.628 5.859-5.859 5.859H5.86A5.866 5.866 0 0 1 0 34.14V9.688c0-1.758.786-3.35 2.031-4.43v1.15c0 3.23 2.629 5.859 5.86 5.859h15.312c3.231 0 5.86-2.629 5.86-5.86zM9.977 25.288a1.172 1.172 0 0 0-1.635.273l-.609.853-.609-.853a1.172 1.172 0 0 0-1.907 1.362l1.076 1.507-1.076 1.506a1.172 1.172 0 0 0 1.907 1.362l.61-.852.608.852a1.17 1.17 0 0 0 1.635.273 1.172 1.172 0 0 0 .272-1.635L9.175 28.43l1.075-1.507a1.172 1.172 0 0 0-.272-1.634zm14.944 2.068h-6.875a1.172 1.172 0 0 0 0 2.344h6.875a1.172 1.172 0 0 0 0-2.344zM11.298 16.6a1.172 1.172 0 0 0-1.65.149l-1.98 2.37-.448-.897a1.172 1.172 0 0 0-2.096 1.05l1.25 2.495a1.172 1.172 0 0 0 1.947.226l3.125-3.742a1.172 1.172 0 0 0-.148-1.65zm13.624 1.6h-6.875a1.172 1.172 0 0 0 0 2.343h6.875a1.172 1.172 0 0 0 0-2.344zM23.203 0a3.52 3.52 0 0 1 3.516 3.516v2.89a3.52 3.52 0 0 1-3.516 3.516H7.891a3.52 3.52 0 0 1-3.516-3.516v-2.89A3.52 3.52 0 0 1 7.891 0z"
      />
    </SvgIcon>
  );
}
export function DownIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 16">
      <path
        d="M7.255 10.36l6.19-9.354a.336.336 0 00.02-.333A.308.308 0 0013.19.5H.81a.308.308 0 00-.275.173.336.336 0 00.02.333l6.19 9.355c.058.087.153.139.255.139a.307.307 0 00.255-.14z"
        fill="#62C3EE"
        fillRule="nonzero"
        transform="translate(0, +4)"
      />
    </SvgIcon>
  );
}
export function EneIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
      <g fillRule="nonzero">
        <path d="M12.5 0C5.608 0 0 5.608 0 12.5S5.608 25 12.5 25 25 19.392 25 12.5 19.392 0 12.5 0zm0 23.077c-5.832 0-10.577-4.745-10.577-10.577S6.668 1.923 12.5 1.923 23.077 6.668 23.077 12.5 18.332 23.077 12.5 23.077z" />
        <path d="M20.48 10c.379 0 .687.307.687.685v3.195a.685.685 0 0 1-1.174.484l-.993-.99-2.933 2.768a.922.922 0 0 1-.74.244l-7.152-.865-3.816 3.38a.916.916 0 0 1-1.294-.076.91.91 0 0 1 .076-1.29l4.125-3.652a.914.914 0 0 1 .719-.224l7.134.861 2.584-2.438-.918-.913A.683.683 0 0 1 17.271 10h3.208z" />
      </g>
    </SvgIcon>
  );
}
export function PendingAssignmentIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd" transform="translate(3 3)">
        <circle
          cx="17"
          cy="17"
          r="17"
          stroke="#F9A825"
          strokeLinecap="round"
          strokeOpacity=".3"
          strokeWidth="4.614"
        />
        <path
          fill="#F9A825"
          fillRule="nonzero"
          d="M11.196 23.38v2.28h-1.084c-.599 0-1.112.51-1.112 1.17 0 .63.485 1.17 1.112 1.17h13.776c.599 0 1.112-.51 1.112-1.17 0-.63-.485-1.17-1.112-1.17h-1.084v-2.28a5.24 5.24 0 0 0-1.768-3.93l-2.282-1.95 2.282-1.95c1.112-.96 1.768-2.4 1.768-3.93V9.34h1.084c.599 0 1.112-.51 1.112-1.17C25 7.51 24.515 7 23.888 7H10.112C9.513 7 9 7.51 9 8.17c0 .66.485 1.17 1.112 1.17h1.084v2.28c0 1.53.656 2.94 1.768 3.93l2.282 1.95-2.282 1.95c-1.14.99-1.768 2.4-1.768 3.93zm2.112-11.498V9.625h7.384v2.257c0 .802-.353 1.574-.97 2.078l-2.707 2.227-2.707-2.227a2.716 2.716 0 0 1-1-2.078zm1 9.158l2.707-2.228 2.706 2.228c.618.504.971 1.276.971 2.078v2.257h-7.384v-2.257c0-.802.382-1.574 1-2.078z"
        />
      </g>
    </SvgIcon>
  );
}
export function NotAssignedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd" transform="translate(3 3)">
        <circle
          cx="17"
          cy="17"
          r="17"
          stroke="#D65252"
          strokeLinecap="round"
          strokeOpacity=".3"
          strokeWidth="4.614"
        />
        <path
          fill="#D65252"
          fillRule="nonzero"
          stroke="#E7454C"
          strokeWidth="1.214"
          d="M25.106 17c0-.64-.517-1.158-1.158-1.158h-5.79v-5.79a1.157 1.157 0 1 0-2.316 0v5.79h-5.79a1.157 1.157 0 1 0 0 2.316h5.79v5.79A1.155 1.155 0 0 0 17 25.106c.64 0 1.158-.517 1.158-1.158v-5.79h5.79c.64 0 1.158-.52 1.158-1.158z"
        />
      </g>
    </SvgIcon>
  );
}
export function StudentDefaultAvatar(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 105 105"
    >
      <defs>
        <path
          id="a"
          d="M52.15.928c28.455 0 51.522 23.067 51.522 51.522s-23.067 51.522-51.522 51.522S.628 80.905.628 52.45 23.695.928 52.15.928z"
        />
        <path
          id="d"
          d="M54.265 67.676h-2.706a2 2 0 0 1-2-2v-1.735a2 2 0 0 1 2-2h2.706a2 2 0 0 1 2 2v1.735a2 2 0 0 1-2 2zm2.088-14.382v2.353a1 1 0 0 1-1 1h-4.794a1 1 0 0 1-1-1V49.03a2 2 0 0 1 2-2h1.353a5.121 5.121 0 0 0 5.117-5.117 5.121 5.121 0 0 0-5.117-5.118c-2.824 0-5.118.294-5.118 3.118H41C41 33.382 46.294 30 52.912 30c6.53 0 11.912 5.294 11.912 11.912 0 5.382-3.53 9.97-8.471 11.382z"
        />
        <filter
          id="c"
          width="158.8%"
          height="137.2%"
          x="-29.4%"
          y="-13.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.623485071 0 0 0 0 0.43005416 0 0 0 0 0.665307971 0 0 0 1 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#EDDDF6" stroke="#B1A0BB" xlinkHref="#a" />
        <path
          fill="#BC97C4"
          fillRule="nonzero"
          stroke="#946C9C"
          strokeWidth=".5"
          d="M62.13 85.392l.036-.061.23.224c.44.426 1.276.985 2.506 1.669l-.014.027c.001 0 .001 0 0 0h0c.05.015.1.027.176.045a44.346 44.346 0 0 0 3.458 1.028c.971.254 2.428.62 4.381 1.102 3.599 1.045 6.254 2.466 7.961 4.267 1.409 1.44 2.35 3.197 2.825 5.265.382 1.714.344 3.703-.111 5.967l-.04.2h-62.26l-.04-.201c-.729-3.712-.317-6.89 1.242-9.521 1.623-2.745 4.67-4.698 9.133-5.868 3.543-.809 5.86-1.348 6.944-1.615.317-.087.666-.21 1.047-.372.675-.278 1.42-.674 2.223-1.183a10.54 10.54 0 0 0 1.114-.883c.162-.147.323-.301.485-.463l.165-.069c.106-.177.224-.356.362-.548.097-.112.188-.23.28-.369.232-.304.442-.63.634-.985l.157-.27.15-.255c.223-.448.44-.895.647-1.341.17-.37.291-.754.36-1.138l.119-1.009.245.026c3.975.417 8.37.372 13.184-.135l.313-.033-.039.313-.11.867c0 .157.007.315.015.434.02.08.03.16.029.221a8.563 8.563 0 0 0 .332 1.812c.013.065.033.137.062.224.185.613.506 1.206.965 1.781l.055.156a.18.18 0 0 0-.042-.123c.146.162.3.324.457.48.12.114.242.225.365.334zm2.603 1.781c-.006-.016-.017-.018-.035-.017l.006.003a2.7 2.7 0 0 0 .029.014zm-.035-.017h-.005l-.017-.012.022.012z"
          mask="url(#b)"
        />
        <path
          fill="#BC97C4"
          fillRule="nonzero"
          stroke="#946C9C"
          strokeWidth=".5"
          d="M78.156 64.645c-1.74 4.684-4.417 8.273-8.03 10.76-3.128 2.133-6.432 3.443-9.91 3.927-.065.01-.133.019-.211.029v.039l-.224.023c-4.847.511-9.276.556-13.278.136l-1.062-.068c-4.662-.453-8.904-1.942-12.722-4.467-4.022-2.67-6.448-5.74-7.265-9.211-1.863.747-3.149 1.157-3.875 1.231a7.027 7.027 0 0 1-3.236-.396c-1.94-.741-3.496-2.152-4.66-4.222-.916-1.622-1.428-3.396-1.535-5.32a12.05 12.05 0 0 1 .896-5.463c.57-1.294 1.356-2.345 2.361-3.15 1.16-.926 2.374-1.292 3.629-1.085 1.064.175 2.05.79 2.95 1.833.184.207.472.54.858.993l-.014-.1-.135-1.101c-.285-2.347-.435-5.037-.45-8.073 0-.904.03-1.78.09-2.626.212-2.676.786-5.136 1.723-7.376 1.211-2.971 3.096-5.601 5.65-7.887 2.554-2.3 5.598-4.04 9.128-5.218a39.28 39.28 0 0 1 10.282-2.011 37.292 37.292 0 0 1 7.999-.045c1.263.15 2.54.354 3.833.61 4.198.844 7.85 2.156 10.956 3.937 3.642 2.089 6.345 4.727 8.103 7.914 1.56 2.807 2.408 6.17 2.543 10.086.015.378.023.755.023 1.133 0 2.276-.267 5.196-.802 8.762 1.001-.73 2.164-1.076 3.488-1.036a6.171 6.171 0 0 1 3.646 1.523c.4.354.77.747 1.11 1.18a5.754 5.754 0 0 1 1.054 2.23 8.906 8.906 0 0 1 .092 3.608l-.24 1.258-.12.632a15.525 15.525 0 0 1-1.436 4.109 10.587 10.587 0 0 1-2.505 3.176 6.401 6.401 0 0 1-.337.27c-1.156.988-2.508 1.607-4.074 1.856-.595.033-1.195-.088-1.81-.363a7.604 7.604 0 0 1-2.276-1.792l-.164-.194-.043-.05z"
          mask="url(#b)"
        />
        <g fillRule="nonzero" mask="url(#b)" opacity=".798">
          <use fill="#000" filter="url(#c)" xlinkHref="#d" />
          <use fill="#FFF" xlinkHref="#d" />
        </g>
        <path
          stroke="#946C9C"
          strokeWidth=".5"
          d="M19.599 58.55c-.24.405-.322.862-.247 1.371.075.495.27.914.584 1.258a2.65 2.65 0 0 0 1.166.742 3.049 3.049 0 0 0 0 0 2.65 2.65 0 0 1-1.166-.742 2.34 2.34 0 0 1-.584-1.258c-.075-.509.008-.966.247-1.37.224-.42.576-.72 1.054-.899.479-.165.935-.15 1.369.045-.479-1.198-1.286-2.194-2.423-2.988-1.152-.794-2.385-1.22-3.701-1.28 1.316.06 2.55.486 3.701 1.28 1.137.794 1.944 1.79 2.423 2.988-.434-.195-.89-.21-1.369-.045-.478.18-.83.48-1.054.899h0zM84.454 54.71c-1.136.793-1.944 1.789-2.423 2.987.434-.195.89-.21 1.369-.045.478.18.83.48 1.054.899.24.404.322.861.247 1.37a2.34 2.34 0 0 1-.583 1.258 2.65 2.65 0 0 1-1.167.742 3.049 3.049 0 0 1 0 0 2.65 2.65 0 0 0 1.167-.742 2.34 2.34 0 0 0 .583-1.258c.075-.509-.007-.966-.247-1.37-.224-.42-.576-.72-1.054-.899-.479-.165-.935-.15-1.369.045.479-1.198 1.287-2.194 2.423-2.988 1.152-.794 2.386-1.22 3.702-1.28-1.316.06-2.55.486-3.702 1.28z"
          mask="url(#b)"
        />
      </g>
    </SvgIcon>
  );
}
export function NoData(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      viewBox="0 0 100 110"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-785 -794)">
          <g transform="translate(789 798)">
            <rect
              id="a"
              x="-2"
              y="-2"
              width="87"
              height="96"
              rx="7"
              fill="#fff"
              stroke="rgb(169 175 187)"
              strokeWidth="4"
            />
            <rect
              x="7"
              y="7"
              width="87"
              height="96"
              rx="7"
              fill="#fff"
              stroke="rgb(169 175 187)"
              strokeWidth="4"
            />
            <path
              transform="translate(51 56) rotate(45) translate(-51 -56)"
              d="m51.095 37c1.8557 0 3.36 1.5043 3.36 3.36l-5.455e-4 12.185 12.186 4.545e-4c1.8557 0 3.36 1.5043 3.36 3.36v0.18909c0 1.8557-1.5043 3.36-3.36 3.36l-12.186-5.455e-4 5.455e-4 12.186c0 1.8557-1.5043 3.36-3.36 3.36h-0.18909c-1.8557 0-3.36-1.5043-3.36-3.36l-4.545e-4 -12.186-12.185 5.455e-4c-1.8557 0-3.36-1.5043-3.36-3.36v-0.18909c0-1.8557 1.5043-3.36 3.36-3.36l12.185-4.545e-4 4.545e-4 -12.185c0-1.8557 1.5043-3.36 3.36-3.36h0.18909z"
              fill="rgb(169 175 187)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function NoStudentIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h120v120H0z" />
        <circle
          cx="36"
          cy="35"
          r="20"
          stroke="#A9AFBB"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.75"
        />
        <path
          stroke="#A9AFBB"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.75"
          d="M6 105V95c0-11.046 8.954-20 20-20h20c11.046 0 20 8.954 20 20v10M71 15.65a20 20 0 0 1 0 38.75M96 105V95a20 20 0 0 0-15-19.25M95 45l20 20m0-20L95 65"
        />
      </g>
    </SvgIcon>
  );
}
export function DeleteIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 26">
      <path
        fill={props.color}
        fillRule="nonzero"
        d="M16.174 0a1.69 1.69 0 0 1 1.678 1.697v2.206h7.014V5.94h-2.132L21.07 25.07c-.046.526-.481.93-1.003.93H5.67c-.522 0-.957-.403-1.003-.929L3.002 5.94H.904V3.903h7.014V1.697c0-.886.676-1.616 1.534-1.69L9.596 0zm4.539 5.94H5.023l1.569 18.023h12.553L20.713 5.94zm-4.941 2.95l2.012.074-.436 12.05-2.012-.075.436-12.05zm-5.774 0l.436 12.049-2.012.074-.436-12.05 2.012-.074zm3.894.037v12.05h-2.014V8.927h2.014zm1.947-6.89H9.932v1.866h5.906V2.037z"
      />
    </SvgIcon>
  );
}
export function CloseIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      sx={{
        color: "rgb(169 175 187)",
        width: "20px !important",
        height: "20px !important",
      }}
      {...props}
    >
      <path d="M29.364 16.636c.595.595.595 1.56 0 2.154L25.154 23l4.21 4.21a1.523 1.523 0 1 1-2.154 2.154L23 25.154l-4.21 4.21a1.523 1.523 0 1 1-2.154-2.154l4.21-4.21-4.21-4.21a1.523 1.523 0 1 1 2.154-2.154L23 20.845l4.21-4.209a1.523 1.523 0 0 1 2.154 0z" />
    </SvgIcon>
  );
}
export function ExcelIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
      <path
        fill="#4dbff1"
        fillRule="nonzero"
        d="M19.615 0v34L0 30.223V3.778L19.615 0zm13.29 3.923c.602 0 1.095.511 1.095 1.138v23.878c0 .627-.493 1.138-1.096 1.138h-11.98v-3.923h3.922v-2.616h-3.923v-2.615h3.923v-2.615h-3.923v-2.616h3.923v-2.615h-3.923V10.48h3.964V7.825h-3.964V3.923zm-1.52 19.615h-5.231v2.616h5.23v-2.616zM15.834 10.396h-3.325l-2.105 3.935c-.203.511-.341.896-.416 1.155h-.036a6.938 6.938 0 0 0-.398-1.117L7.66 10.397H4.03l3.862 6.624-4.221 6.622h3.555l2.29-4.276c.16-.413.263-.722.306-.925h.035c.093.43.182.726.268.887l2.282 4.314 3.538-.001-4.083-6.679 3.972-6.567zm15.55 7.912h-5.23v2.615h5.23v-2.615zm0-5.231h-5.23v2.615h5.23v-2.615zm0-5.23h-5.23v2.615h5.23V7.846z"
      />
    </SvgIcon>
  );
}
export function PrintIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 34">
      <path
        fill="#4dbff1"
        fillRule="nonzero"
        d="M28.852 7.504H5.876v-5.18A2.324 2.324 0 0 1 8.2 0h18.328a2.324 2.324 0 0 1 2.324 2.324v5.18zm-.996 12.55c.55 0 .996.447.996.997v10.625A2.327 2.327 0 0 1 26.528 34H8.2a2.327 2.327 0 0 1-2.324-2.324V21.05c0-.55.446-.996.996-.996h20.984zm-3.852 9.962a.996.996 0 1 0 0-1.993h-13.28a.996.996 0 1 0 0 1.993h13.28zm0-3.985a.996.996 0 1 0 0-1.992h-13.28a.996.996 0 1 0 0 1.992h13.28zM32.04 9.496a2.327 2.327 0 0 1 2.324 2.324v14.344a2.327 2.327 0 0 1-2.324 2.324h-1.196v-7.437a2.992 2.992 0 0 0-2.988-2.988H6.872a2.992 2.992 0 0 0-2.989 2.988v7.437H2.688a2.327 2.327 0 0 1-2.324-2.324V11.82a2.327 2.327 0 0 1 2.324-2.324H32.04zm-2.989 6.309a.996.996 0 1 0 0-1.992.996.996 0 0 0 0 1.992z"
      />
    </SvgIcon>
  );
}
export function SpreadSheetDownloadIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 29">
      <path
        fill="#62C3EE"
        fillRule="nonzero"
        d="M31.3 13.793a1.6 1.6 0 0 1 1.601 1.6v6.693a6.845 6.845 0 0 1-6.838 6.837H7.545a6.845 6.845 0 0 1-6.837-6.837v-6.692a1.6 1.6 0 1 1 3.201 0v6.692a3.641 3.641 0 0 0 3.636 3.637h18.518a3.642 3.642 0 0 0 3.638-3.637v-6.692a1.6 1.6 0 0 1 1.6-1.6zM19.225.05c.98 0 1.774.795 1.774 1.776v9.665h3.258a1.334 1.334 0 0 1 .942 2.275l-7.453 7.454c-.521.52-1.364.52-1.886 0l-7.453-7.454a1.332 1.332 0 0 1 .942-2.276h3.257V1.826c0-.981.795-1.776 1.775-1.776z"
      />
    </SvgIcon>
  );
}
export function LongArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 55 36">
      <path
        fill="#C6C6C6"
        d="M10.223 12.057a.537.537 0 0 1 .777.48v7.926a.537.537 0 0 1-.777.48L2.297 16.98a.537.537 0 0 1 0-.96zM50.5 16a.5.5 0 0 1 .09.992L50.5 17h-3a.5.5 0 0 1-.09-.992L47.5 16h3zm-6 0a.5.5 0 0 1 .09.992L44.5 17h-3a.5.5 0 0 1-.09-.992L41.5 16h3zm-6 0a.5.5 0 0 1 .09.992L38.5 17h-3a.5.5 0 0 1-.09-.992L35.5 16h3zm-6 0a.5.5 0 0 1 .09.992L32.5 17h-3a.5.5 0 0 1-.09-.992L29.5 16h3zm-6 0a.5.5 0 0 1 .09.992L26.5 17h-3a.5.5 0 0 1-.09-.992L23.5 16h3zm-6 0a.5.5 0 0 1 .09.992L20.5 17h-3a.5.5 0 0 1-.09-.992L17.5 16h3zm-6 0a.5.5 0 0 1 .09.992L14.5 17h-3a.5.5 0 0 1-.09-.992L11.5 16h3z"
      />
    </SvgIcon>
  );
}
export function UploadIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 26">
      <path
        fillRule="nonzero"
        d="M26.529 12.787c.763 0 1.382.619 1.382 1.382v5.78a5.911 5.911 0 0 1-5.905 5.905H6.013a5.911 5.911 0 0 1-5.905-5.905v-5.78a1.382 1.382 0 1 1 2.765 0v5.78a3.145 3.145 0 0 0 3.14 3.141h15.993a3.145 3.145 0 0 0 3.141-3.141v-5.78c0-.763.62-1.382 1.382-1.382zM14.822 1.255l6.438 6.437a1.152 1.152 0 0 1-.813 1.965h-2.814v8.347c0 .847-.687 1.534-1.533 1.534h-4.184a1.533 1.533 0 0 1-1.532-1.534V9.657H7.57a1.151 1.151 0 0 1-.813-1.965l6.436-6.437c.45-.45 1.179-.45 1.628 0z"
      />
    </SvgIcon>
  );
}
export function SendIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 29">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M30.625.445a.45.45 0 0 0-.487-.07L.933 13.945a.45.45 0 0 0-.008.812l8.265 4.056a.45.45 0 0 0 .467-.044l8.036-6.006-6.308 6.49a.45.45 0 0 0-.126.347l.628 8.18a.45.45 0 0 0 .79.26l4.386-5.083 5.423 2.59a.45.45 0 0 0 .623-.27L30.757.917a.45.45 0 0 0-.132-.473z"
      />
    </SvgIcon>
  );
}
export function PassCodeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 27">
      <path
        fill="#62C3EE"
        fillRule="nonzero"
        d="M22.74 2.284A7.652 7.652 0 0 0 17.27 0a7.65 7.65 0 0 0-5.467 2.284 7.841 7.841 0 0 0-1.702 8.443l.035.086L.203 20.832a.705.705 0 0 0-.203.495V26.3c0 .386.311.7.695.7H3.85c.384 0 .68-.313.68-.7l.005-4.122 4.134-.002a.693.693 0 0 0 .694-.7l.001-3.119 3.9-3.93a7.861 7.861 0 0 0 4.078 1.15c2.033 0 3.95-.804 5.397-2.263 3.013-3.04 3.013-7.988 0-11.03zm-.785 5.113l-1.08 1.089a.552.552 0 0 1-.784 0l-3.5-3.531a.564.564 0 0 1 0-.792l1.079-1.089a.552.552 0 0 1 .785 0l3.5 3.531a.563.563 0 0 1 0 .792z"
      />
    </SvgIcon>
  );
}
export function SpreadSheetErrorsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 43 43">
      <g fill="none" fillRule="evenodd">
        <circle cx="21.5" cy="21.5" r="21.5" fill="#FFE2E6" />
        <path
          fill="#F54F64"
          fillRule="nonzero"
          d="M23.02 10v24.3L9 31.6V12.7L23.02 10zm9.497 2.804c.43 0 .783.365.783.813v17.066c0 .448-.352.813-.783.813h-8.563v-2.804h2.804v-1.869h-2.804v-1.87h2.804v-1.868h-2.804v-1.87h2.804v-1.869h-2.804v-1.855h2.833v-1.898h-2.833v-2.79zm-1.086 14.02h-3.739v1.868h3.739v-1.869zM20.316 17.43h-2.375l-1.505 2.812a9.94 9.94 0 0 0-.297.826h-.027a4.959 4.959 0 0 0-.284-.798l-1.353-2.839H11.88l2.76 4.734-3.017 4.733h2.542l1.636-3.056c.115-.296.188-.516.219-.661h.025c.066.307.13.519.192.634l1.63 3.083 2.529-.001-2.918-4.773 2.838-4.694zm11.115 5.655h-3.739v1.869h3.739v-1.87zm0-3.739h-3.739v1.87h3.739v-1.87zm0-3.738h-3.739v1.869h3.739v-1.87z"
        />
        <path
          fill="#F54F64"
          fillRule="nonzero"
          d="M26.505 31.632v3.803l-1.044-.886a.944.944 0 0 0-1.223 1.44l2.601 2.209c.352.3.87.299 1.223-.001l2.6-2.209a.944.944 0 0 0-1.223-1.439l-1.044.886v-3.803a.944.944 0 1 0-1.89 0z"
        />
      </g>
    </SvgIcon>
  );
}
export function SearchIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28">
      <g fill="none" fillRule="evenodd" transform="translate(0 .817)">
        <path d="M0 0h26.4v26.4H0z" />
        <circle
          cx="11"
          cy="11"
          r="7.7"
          stroke="#62C3EE"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          stroke="#62C3EE"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M23.1 23.1l-6.6-6.6"
        />
      </g>
    </SvgIcon>
  );
}
export function RemoveIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14">
      <path
        fill={props.color}
        fillRule="nonzero"
        d="M13.462 2.744L9.241 6.967l4.221 4.221a1.608 1.608 0 0 1-2.273 2.274L6.967 9.24l-4.223 4.222c-.313.314-.725.471-1.136.471A1.608 1.608 0 0 1 .47 11.188l4.222-4.222L.47 2.744A1.608 1.608 0 0 1 2.744.471l4.223 4.222L11.189.47a1.608 1.608 0 0 1 2.273 2.273z"
      />
    </SvgIcon>
  );
}
export function PrintAllQRIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 34 34">
      <path
        fillRule="nonzero"
        d="M27.492 20.055c.55 0 .996.446.996.996v10.625A2.327 2.327 0 0 1 26.164 34H7.836a2.327 2.327 0 0 1-2.324-2.324V21.05c0-.55.446-.996.996-.996zm-3.851 7.968H10.359a.996.996 0 1 0 0 1.993h13.282a.996.996 0 1 0 0-1.993zm8.035-18.527A2.327 2.327 0 0 1 34 11.82v14.344a2.327 2.327 0 0 1-2.324 2.324H30.48v-7.437a2.992 2.992 0 0 0-2.988-2.988H6.508A2.992 2.992 0 0 0 3.52 21.05v7.437H2.324A2.327 2.327 0 0 1 0 26.164V11.82a2.327 2.327 0 0 1 2.324-2.324zM23.64 24.04H10.359a.996.996 0 1 0 0 1.992h13.282a.996.996 0 1 0 0-1.992zm5.047-10.227a.996.996 0 1 0 0 1.993.996.996 0 0 0 0-1.992zM26.163 0a2.324 2.324 0 0 1 2.324 2.324v5.18H5.512v-5.18A2.324 2.324 0 0 1 7.836 0h18.328z"
      />
    </SvgIcon>
  );
}
export function SendEmailIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 21">
      <path
        fill="#62C3EE"
        fillRule="nonzero"
        d="M18.752 11.397l8.795 8.738a2.52 2.52 0 0 1-1.092.256H2.553a2.52 2.52 0 0 1-1.092-.256l8.795-8.738L11.5 12.64a4.252 4.252 0 0 0 6.007 0l1.245-1.244zm10-9.94c.159.332.255.7.255 1.092v15.293c0 .392-.096.76-.255 1.092l-8.795-8.739zm-28.497 0l8.796 8.738-8.796 8.739A2.519 2.519 0 0 1 0 17.842V2.549c0-.393.096-.76.255-1.092zM26.455 0c.392 0 .76.096 1.092.255L16.306 11.44a2.55 2.55 0 0 1-3.604 0L1.46.255A2.52 2.52 0 0 1 2.553 0z"
      />
    </SvgIcon>
  );
}
export function SaSubmittedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 27">
      <g fill="none" fillRule="nonzero">
        <path
          fill="#A9AFBB"
          d="M22.837 12.236c-.263-3.012-2.066-5.79-4.591-7.453-1.384-.912-2.988-1.471-4.634-1.683-4.536-.583-9.314 1.387-11.025 5.793-1.471 3.789-.02 7.55 2.614 10.417.95 1.035 1.082 2.981 1.082 4.292v2.659c0 .408.335.739.748.739h9.727c.394 0 .72-.302.746-.69.036-.524.094-.983.094-.983.204-.863.948-1.555 2.53-1.304 1.659.264 2.705-.225 2.798-1.318.03-.36.05-3.439.05-3.439.08-.045.6-.147 1.358-.317a.754.754 0 0 0 .368-1.277c-1.724-1.687-1.955-2.473-1.998-2.642-.214-.84.21-1.91.133-2.794zm-3.212-1.006c-.24.3-.513.358-.657.366a.073.073 0 0 0-.068.093c.074.258.15.969-1.137 1.246-1.207.26-1.937 1.188-2.414 1.659-.366.362-.861.53-1.355.64-.505.111-1.005.21-1.403.564-.42.374-1.011 2.431-1.112 2.789a.073.073 0 0 1-.07.053h-.62a.073.073 0 0 1-.072-.058l-.3-1.404c-.013-.059-2.923.178-3.147-1.107a.074.074 0 0 0-.097-.057c-.28.1-1.178.345-1.662-.397a1.457 1.457 0 0 1-.205-1.188.072.072 0 0 0-.041-.086c-.247-.105-1.14-.6-1.018-2.226.097-1.312.994-1.894.869-2.095-.362-.582-.047-1.547.694-1.762a.075.075 0 0 0 .054-.065l.031-.342C5.998 6.647 7.6 5.883 8.69 6.384a.077.077 0 0 0 .106-.045c.136-.427.411-.545.485-.585.337-.188.776-.165 1.125-.023.028.011.06.004.081-.018.1-.105.506-.438 1.18-.438.69 0 1.041.331 1.164.424.023.017.053.02.078.008.156-.079.723-.33 1.291-.137.43.147.673.533.75.673.016.03.05.046.084.038.204-.048.908-.182 1.5.083.625.28.82.683.87.819.01.027.037.046.066.047.136.005.51.038.741.23.409.34.369.607.322.722a.072.072 0 0 0 .036.092c.186.09.71.389 1.034 1.024.446.874.268 1.625.023 1.932z"
        />
        <path
          fill="#6DC679"
          stroke="#FFF"
          d="M5.5.5c1.379 0 2.629.56 3.534 1.466A4.985 4.985 0 0 1 10.5 5.5c0 1.378-.56 2.629-1.466 3.534A4.985 4.985 0 0 1 5.5 10.5a4.985 4.985 0 0 1-3.534-1.466A4.985 4.985 0 0 1 .5 5.5c0-1.379.56-2.629 1.466-3.534A4.985 4.985 0 0 1 5.5.5zm1.947 3.784l-2.64 2.64L3.27 5.773l1.633 1.44 2.544-2.929z"
        />
      </g>
    </SvgIcon>
  );
}
export function AssignIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M20.48.014c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20zm0 2.623c-9.582 0-17.377 7.795-17.377 17.377 0 9.582 7.795 17.377 17.376 17.377 9.582 0 17.378-7.795 17.378-17.377 0-9.582-7.796-17.377-17.377-17.377zm0 8.118c.724 0 1.312.587 1.312 1.311v6.636h6.636a1.312 1.312 0 0 1 0 2.624H21.79v6.636a1.312 1.312 0 0 1-2.623 0v-6.636h-6.636a1.312 1.312 0 0 1 0-2.623h6.636v-6.637c0-.724.588-1.311 1.312-1.311z"
      />
    </SvgIcon>
  );
}
export function InProgress(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 34" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.397)">
        <circle
          cx="17"
          cy="17"
          r="16"
          stroke="#62C3EE"
          strokeOpacity=".3"
          strokeWidth="2"
        />
        <path
          fill="#62C3EE"
          fillRule="nonzero"
          d="M16.677 17.627a.852.852 0 0 1-.255-.544V5C10.116 5.37 5 10.685 5 17.083c0 6.637 5.494 12.083 12.13 12.083 3.456 0 6.567-1.519 8.764-3.858l-9.217-7.68z"
        />
      </g>
    </SvgIcon>
  );
}
export function PendingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
      <g fill="none" fillRule="evenodd">
        <circle
          cx="17"
          cy="17"
          r="16"
          stroke="#F9A825"
          strokeOpacity=".3"
          strokeWidth="2"
        />
        <path
          fill="#F9A825"
          fillRule="nonzero"
          d="M11.196 23.38v2.28h-1.084c-.599 0-1.112.51-1.112 1.17 0 .63.485 1.17 1.112 1.17h13.776c.599 0 1.112-.51 1.112-1.17 0-.63-.485-1.17-1.112-1.17h-1.084v-2.28a5.24 5.24 0 0 0-1.768-3.93l-2.282-1.95 2.282-1.95c1.112-.96 1.768-2.4 1.768-3.93V9.34h1.084c.599 0 1.112-.51 1.112-1.17C25 7.51 24.515 7 23.888 7H10.112C9.513 7 9 7.51 9 8.17c0 .66.485 1.17 1.112 1.17h1.084v2.28c0 1.53.656 2.94 1.768 3.93l2.282 1.95-2.282 1.95c-1.14.99-1.768 2.4-1.768 3.93zm2.112-11.498V9.625h7.384v2.257c0 .802-.353 1.574-.97 2.078l-2.707 2.227-2.707-2.227a2.716 2.716 0 0 1-1-2.078zm1 9.158l2.707-2.228 2.706 2.228c.618.504.971 1.276.971 2.078v2.257h-7.384v-2.257c0-.802.382-1.574 1-2.078z"
        />
      </g>
    </SvgIcon>
  );
}
export function CompletedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
      <g fill="none" fillRule="evenodd">
        <circle
          cx="17"
          cy="17"
          r="16"
          stroke="#8DDF24"
          strokeOpacity=".3"
          strokeWidth="2"
        />
        <path
          fill="#8DDF24"
          fillRule="nonzero"
          d="M25.43 14.445l-8.676 8.964a1.908 1.908 0 0 1-2.76 0L9.571 18.84A2.039 2.039 0 0 1 9 17.413c0-.539.203-1.045.572-1.426a1.908 1.908 0 0 1 2.761 0l3.04 3.141 7.294-7.537a1.908 1.908 0 0 1 2.762 0 2.068 2.068 0 0 1 0 2.854z"
        />
      </g>
    </SvgIcon>
  );
}
export function NewLoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 71 82">
      <defs>
        <linearGradient
          id="a"
          x1="-22.504%"
          x2="69.293%"
          y1="125.168%"
          y2="4.647%"
        >
          <stop offset="0%" stopColor="#AEEA5D" />
          <stop offset="100%" stopColor="#86C630" />
        </linearGradient>
        <text id="c" fill="#FFF" fontSize="21" fontWeight="bold">
          <tspan x="48.614" y="38.273">
            جديد
          </tspan>
        </text>
        <filter
          id="b"
          width="102.5%"
          height="105.6%"
          x="-1.2%"
          y="-1.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#F4A100" d="M26.2 78.3V51.7L9.05 73.05z" />
        <path
          fill="#6C9B2D"
          stroke="#FFF"
          strokeWidth="2.1"
          d="M50.539 1.845l.168.001c.482.027.908.246 1.207.58.3.333.47.78.444 1.263-.405 7.405-.608 11.976-.608 13.711 0 .622.069 1.116.297 1.445.148.213.385.291.67.303h0l14.684 1.583c.793.086 1.473.707 1.565 1.611h0l-41.717 36.54.001 20.838-19.24-5.89-.018-1.395c-.217-16.283-.33-25.969-.341-29.062-.001-3.209.753-5.438 2.187-7.208h0L49.475 2.262a1.75 1.75 0 0 1 1.232-.416z"
        />
        <path
          fill="url(#a)"
          d="M9.05 71.05l58.617-50.047a.7.7 0 0 0-.38-1.228L52.8 18.2c-1.4 0-2.1-.933-2.1-2.8 0-1.743.203-6.332.61-13.768a.7.7 0 0 0-1.153-.57L10.8 34.65c-1.4 1.633-2.1 3.733-2.1 6.3 0 2.567.117 12.6.35 30.1z"
          transform="translate(0 2)"
        />
        <g fill="#FFF" transform="rotate(-36 33.691 33.273)">
          <use filter="url(#b)" xlinkHref="#c" />
          <use xlinkHref="#c" />
        </g>
      </g>
    </SvgIcon>
  );
}
export function ProfileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h28v28H0z" />
        <circle
          cx="14"
          cy="8.167"
          r="4.667"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M7 24.5v-2.333a4.667 4.667 0 0 1 4.667-4.667h4.666A4.667 4.667 0 0 1 21 22.167V24.5"
        />
      </g>
    </SvgIcon>
  );
}
export function StudentsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 36 29">
      <g fill="#62C3EE" fillRule="nonzero">
        <path d="M31.25 19A4.756 4.756 0 0 1 36 23.75v3.5a.75.75 0 0 1-.75.75h-16.5a.75.75 0 0 1-.75-.75v-3.5A4.756 4.756 0 0 1 22.75 19zM27 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        <path
          stroke="#F9F9F9"
          d="M17.93 15.929c1.768 0 3.374.705 4.556 1.85a6.607 6.607 0 0 1 2.01 4.519h0l.004 4.738a1.462 1.462 0 0 1-1.32 1.458h0L1.958 28.5a1.464 1.464 0 0 1-1.452-1.326h0L.5 22.536c0-1.777.7-3.392 1.838-4.58a6.535 6.535 0 0 1 4.495-2.023h0zM12.5.5c1.903 0 3.625.776 4.872 2.03A6.927 6.927 0 0 1 19.39 7.43c0 1.913-.77 3.644-2.017 4.898a6.848 6.848 0 0 1-4.872 2.03 6.848 6.848 0 0 1-4.872-2.03A6.927 6.927 0 0 1 5.61 7.429c0-1.913.77-3.645 2.017-4.899A6.848 6.848 0 0 1 12.5.5z"
        />
      </g>
    </SvgIcon>
  );
}
export function HelpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h28.116v28.116H0z" />
        <circle
          cx="14.058"
          cy="14.058"
          r="10.543"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M14.058 19.916v.011M14.058 15.815a1.757 1.757 0 0 1 1.171-1.757 3.046 3.046 0 1 0-3.514-4.686"
        />
      </g>
    </SvgIcon>
  );
}
export function GameIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 84 69">
      <defs>
        <path id="a" d="M.191.207h14.953v9.558H.191z" />
        <path id="c" d="M.064.207h14.953v9.558H.064z" />
        <path id="e" d="M.001.067h65.11V24.72H.001z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FF3897"
          stroke="#FFF"
          strokeWidth="4.8"
          d="M59.897 20.745c1.87-.337 4.35.237 6.614 1.696 3.302 2.127 4.97 5.378 3.943 7.503l-.023.045-.03.06-.01.017h0l.036.058c1.47 2.4 2.304 5.026 2.465 7.93.175 3.152-.434 7.013-1.528 10.733-.08.272-.163.543-.248.814a41.807 41.807 0 0 1-2.208 5.605c-.639 1.318-1.328 2.526-2.048 3.568l-.08.117.08-.117a15.412 15.412 0 0 1-1.626 2.006 8.535 8.535 0 0 1-.434.417 11.795 11.795 0 0 1-.216.188l-.057.048a6.888 6.888 0 0 1-.776.562l-.06.036a5.505 5.505 0 0 1-.504.266 4.783 4.783 0 0 1-.244.101 3.792 3.792 0 0 1-.63.177 3.11 3.11 0 0 1-.415.047 2.805 2.805 0 0 1-.63-.044l.17.026h0l-.17-.026a4.23 4.23 0 0 1-.214-.045l-.212-.057h0l-.208-.067h0c-1.943-.679-3.506-2.746-5.152-5.532-1.155-1.957-2.351-4.268-3.748-6.702a74.491 74.491 0 0 1-2.4-4.54 111.15 111.15 0 0 1-.47-.978h0l-.376.097c-1.478.36-3.074.52-4.73.46a20.413 20.413 0 0 1-6.217-1.237c-3.436-1.25-6.281-3.276-8.273-5.661h0l-.37.164a73.9 73.9 0 0 1-4.405 1.78c-2.378.872-4.567 1.774-6.547 2.497-3.225 1.178-5.896 1.884-7.928 1.227l-.208-.073h0l-.202-.083a4.25 4.25 0 0 1-.539-.284 2.845 2.845 0 0 1-.687-.629 3.403 3.403 0 0 1-.367-.56 4.494 4.494 0 0 1-.16-.327l-.022-.053a4.944 4.944 0 0 1-.193-.54 6.515 6.515 0 0 1-.18-.753 8.178 8.178 0 0 1-.099-.683 10.531 10.531 0 0 1-.06-.96 9.066 9.066 0 0 1-.003-.37v-.084a17.108 17.108 0 0 1 .08-1.461l-.013.143a20.736 20.736 0 0 1 .14-1.212c.18-1.256.474-2.597.862-3.973a41.254 41.254 0 0 1 1.045-3.19c1.627-4.375 4.038-8.72 6.663-11.517 2.076-2.213 4.519-3.724 7.333-4.603.613-2.261 3.961-3.658 7.833-3.168 2.04.258 3.846.992 5.127 1.975l.032.025c.053.04.104.08.154.122l.057.048.107.09.067.06c.045.04.09.08.132.122l.024.022.047.045.109.11a6.03 6.03 0 0 1 .3.333l.04.049c.632.123 1.275.26 1.927.412.018.005.036.01.054.013l.018.004c.495.116.997.24 1.504.37.03.01.06.017.09.025.33.085.662.175.997.267l.048.014a76.648 76.648 0 0 1 2.861.854 91.127 91.127 0 0 1 3.084 1.041c.256.09.513.183.77.277h0l.522.192a109.182 109.182 0 0 1 2.379.912 82.28 82.28 0 0 1 3.598 1.53l.022.01a61.17 61.17 0 0 1 4.118 2.052l.345.191h0z"
        />
        <g transform="rotate(20 -6.922 75.279)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#FF3897"
            d="M15.047 3.31c.658 2.472-2.114 5.225-6.19 6.15-4.075.926-7.912-.327-8.57-2.799-.657-2.47 2.115-5.224 6.19-6.15 4.076-.924 7.913.329 8.57 2.8"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#E82275"
          d="M23.321 13.266c-.227 2.546 2.95 5.037 7.096 5.56 4.146.526 7.692-1.114 7.92-3.66.12-1.356-.722-2.695-2.162-3.73-4.703-.756-8.81-.66-12.337.419-.29.427-.471.9-.517 1.41"
        />
        <g transform="rotate(20 -24.562 175.32)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#FF3C9C"
            d="M.16 3.31c-.656 2.472 2.115 5.225 6.19 6.15 4.076.926 7.914-.327 8.57-2.799.658-2.47-2.114-5.224-6.19-6.15C4.656-.412.819.84.16 3.312"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#E82275"
          d="M70.224 30.337c.247-.353.402-.748.477-1.17-1.979-3.197-5.09-5.991-9.255-8.5-1.722-.105-3.183.38-3.946 1.473-1.462 2.097.2 5.633 3.714 7.896 3.513 2.264 7.547 2.398 9.01.3"
        />
        <path
          fill="#0077C3"
          d="M72.892 38.055c-.555-9.991-9.06-16.698-24.102-22.173-15.04-5.474-25.868-5.804-32.715 1.493-6.531 6.96-11.736 23.498-6.858 26.258 3.248 1.838 8.492-.884 15.276-3.373a74.833 74.833 0 0 0 4.775-1.944c1.992 2.385 4.837 4.41 8.273 5.661 3.951 1.439 7.963 1.59 11.323.68a77.52 77.52 0 0 0 2.87 5.518c3.596 6.267 5.864 11.723 9.534 12.403 5.51 1.021 12.153-14.993 11.624-24.523"
        />
        <path
          fill="#0077C3"
          d="M72.892 38.055c-.555-9.991-9.06-16.698-24.102-22.173-15.04-5.474-25.868-5.804-32.715 1.493-6.531 6.96-11.736 23.498-6.858 26.258 3.248 1.838 8.492-.884 15.276-3.373a74.833 74.833 0 0 0 4.775-1.944c1.992 2.385 4.837 4.41 8.273 5.661 3.951 1.439 7.963 1.59 11.323.68a77.52 77.52 0 0 0 2.87 5.518c3.596 6.267 5.864 11.723 9.534 12.403 5.51 1.021 12.153-14.993 11.624-24.523"
        />
        <path
          fill="#0080D3"
          d="M19.831 14.357c4.27 3.454 10.25 6.78 17.195 9.307 12.537 4.564 24.342 5.117 29.502 1.844-4.084-3.712-10.056-6.83-17.738-9.626-12.536-4.563-22.142-5.547-28.959-1.525"
        />
        <path
          fill="#0065B7"
          d="M72.892 38.055a17.79 17.79 0 0 0-.139-1.402c-2.02 7.881-6.81 15.592-10.862 14.808-3.282-.635-6.724-2.358-9.59-7.837a67.802 67.802 0 0 1-2.342-4.988c-3.082.867-6.937 1.485-10.434.212-3.034-1.104-5.297-3.65-7.097-5.84a.174.174 0 0 0-.225-.039c-1.21.724-2.458 1.3-3.934 1.908-5.717 2.355-9.462 1.463-12.384-.16-3.608-2.005-2.32-10.99 1.197-18.327-.343.313-.681.638-1.007.985-6.531 6.96-11.736 23.498-6.858 26.258 3.248 1.838 8.492-.884 15.276-3.373a74.618 74.618 0 0 0 4.775-1.944c1.992 2.385 4.837 4.41 8.273 5.661 3.951 1.439 7.963 1.59 11.323.68a77.52 77.52 0 0 0 2.87 5.518c3.596 6.267 5.864 11.723 9.534 12.403 5.51 1.021 12.153-14.993 11.624-24.523"
        />
        <g transform="rotate(20 -46.758 46.501)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#e" />
          </mask>
          <path
            fill="#004CA0"
            d="M63.651.067C65.134 9.1 63.44 20.9 59.024 21.635c-3.534.589-7.258-3.585-12.485-8.1a74.142 74.142 0 0 1-4.377-4.113c-2.774 1.967-6.474 3.169-10.535 3.169-3.532 0-6.79-.91-9.407-2.438a71.263 71.263 0 0 1-3.648 3.383c-5.227 4.514-8.95 8.688-12.484 8.1C1.672 20.9-.023 9.1 1.46.065c-2.726 9.195-1.655 23.75 3.4 24.596 3.681.616 7.678-3.736 13.201-8.395a74.608 74.608 0 0 0 3.822-3.46c2.688 1.56 6.054 2.49 9.71 2.49 4.206 0 8.027-1.229 10.873-3.233a77.68 77.68 0 0 0 4.585 4.203c5.523 4.66 9.52 9.01 13.2 8.395 5.055-.847 6.127-15.401 3.4-24.595"
            mask="url(#f)"
          />
        </g>
        <path
          fill="#004CA0"
          d="M32.954 25l-3.397-1.237-.009-.002.004-.008 1.236-3.398a1.213 1.213 0 0 0-.724-1.554l-3.398-1.237a1.213 1.213 0 0 0-1.554.725l-1.237 3.398-.002.008c-.003 0-.005-.003-.008-.004l-3.398-1.237a1.213 1.213 0 0 0-1.554.725l-1.237 3.398c-.229.63.096 1.325.725 1.554l3.398 1.237.008.002c0 .003-.002.005-.003.008l-1.237 3.398c-.23.63.095 1.325.725 1.554l3.397 1.237a1.213 1.213 0 0 0 1.554-.725l1.237-3.398.002-.008c.003 0 .006.002.009.004l3.397 1.236c.63.23 1.325-.095 1.554-.724l1.237-3.398A1.212 1.212 0 0 0 32.954 25M60.471 38.889a3.663 3.663 0 0 0-.937-.205c.18-.257.333-.54.446-.849.112-.309.177-.623.204-.937.258.18.54.334.85.446.308.113.623.177.936.204-.18.258-.333.54-.446.85-.112.309-.176.623-.204.937a3.665 3.665 0 0 0-.849-.446m5.783-2.697a3.662 3.662 0 0 0-.936-.204c.18-.258.333-.54.445-.85a3.695 3.695 0 0 0-2.205-4.73 3.695 3.695 0 0 0-4.73 2.206c-.113.31-.177.624-.205.937a3.664 3.664 0 0 0-.849-.446 3.695 3.695 0 0 0-4.73 2.206 3.695 3.695 0 0 0 2.206 4.73c.309.113.624.177.937.204-.18.258-.334.54-.446.85a3.695 3.695 0 0 0 2.206 4.73 3.695 3.695 0 0 0 4.73-2.206c.112-.31.176-.624.204-.937.258.18.54.333.849.446a3.695 3.695 0 0 0 4.73-2.206 3.695 3.695 0 0 0-2.206-4.73"
        />
        <path
          fill="#FFF"
          d="M28.413 23.338l-2.356 1.187-1.042-2.424 1.237-3.398 3.397 1.237zM22.943 27.793l2.356-1.187 1.042 2.424-1.237 3.398-3.398-1.237zM27.905 28.3l-1.187-2.356 2.424-1.041 3.397 1.236-1.236 3.397zM23.45 22.831l1.187 2.355-2.424 1.042-3.398-1.237 1.237-3.397zM64.624 34.724a2.478 2.478 0 1 1-4.657-1.695 2.478 2.478 0 0 1 4.657 1.695"
        />
        <path
          fill="#FFDC00"
          d="M63.6 34.351a1.388 1.388 0 1 1-2.61-.95 1.388 1.388 0 0 1 2.61.95"
        />
        <path
          fill="#FFF"
          d="M61.537 43.204a2.478 2.478 0 1 1-4.656-1.695 2.478 2.478 0 0 1 4.656 1.695"
        />
        <path
          fill="#FF3C9C"
          d="M60.513 42.831a1.388 1.388 0 1 1-2.608-.95 1.388 1.388 0 0 1 2.608.95"
        />
        <path
          fill="#FFF"
          d="M64.145 41.988a2.478 2.478 0 1 1 1.694-4.657 2.478 2.478 0 0 1-1.694 4.657M55.665 38.902a2.478 2.478 0 1 1 1.694-4.657 2.478 2.478 0 0 1-1.694 4.657"
        />
        <path
          fill="#FF3C9C"
          d="M64.517 40.964a1.388 1.388 0 1 1 .95-2.608 1.388 1.388 0 0 1-.95 2.608"
        />
        <path
          fill="#FFDC00"
          d="M56.037 37.878a1.388 1.388 0 1 1 .95-2.609 1.388 1.388 0 0 1-.95 2.609"
        />
        <path
          fill="#0077C3"
          d="M46.783 34.426a4.456 4.456 0 1 1-8.375-3.048 4.456 4.456 0 0 1 8.375 3.048"
        />
        <path
          fill="#FFF"
          d="M45.256 32.269a2.283 2.283 0 1 1-4.291-1.562 2.283 2.283 0 0 1 4.29 1.562"
        />
        <path
          fill="#0065B7"
          d="M41.586 35.676a3.655 3.655 0 1 1 2.5-6.87 3.655 3.655 0 0 1-2.5 6.87m2.534-6.962a4.456 4.456 0 1 0-3.048 8.375 4.456 4.456 0 0 0 3.048-8.375"
        />
        <path
          fill="#004CA0"
          d="M41.26 36.573a4.147 4.147 0 1 1 2.836-7.793 4.147 4.147 0 0 1-2.836 7.793m2.86-7.859a4.456 4.456 0 1 0-3.048 8.375 4.456 4.456 0 0 0 3.048-8.375"
        />
        <path
          fill="#009CE3"
          d="M40.275 15.885c-.053.594-3.634-.2-7.698-.56-4.063-.362-7.07-.154-7.017-.748.052-.594 3.266-1.507 7.33-1.146 4.063.362 7.437 1.86 7.385 2.454M63.087 25.654c-.225.357-2.099-1.04-4.536-2.58-2.438-1.54-4.637-2.9-4.412-3.257.225-.356 3.005.689 5.443 2.23 2.437 1.54 3.73 3.251 3.505 3.607"
        />
      </g>
    </SvgIcon>
  );
}
export function NotificationsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h28v28H0z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M12.125 6.286C12.125 5.023 13.188 4 14.5 4s2.375 1.023 2.375 2.286c2.779 1.264 4.606 3.902 4.75 6.857v3.428C21.806 18.012 22.688 19.285 24 20H5c1.312-.715 2.194-1.988 2.375-3.429v-3.428c.144-2.955 1.971-5.593 4.75-6.857M11 20v1.25c0 2.071 1.567 3.75 3.5 3.75s3.5-1.679 3.5-3.75V20"
        />
      </g>
    </SvgIcon>
  );
}
export function LessonIcon(props: SvgIconProps) {
  const { color, ...reset } = props;
  return (
    <SvgIcon {...reset} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h34.027v34.027H0z" />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.127"
          d="M8.507 5.671h15.595a2.836 2.836 0 0 1 2.836 2.836V25.52a2.836 2.836 0 0 1-2.836 2.836H8.507a1.418 1.418 0 0 1-1.418-1.418V7.088c0-.782.635-1.417 1.418-1.417m4.253 0v25.52M18.431 11.342h2.836M18.431 17.013h2.836"
        />
      </g>
    </SvgIcon>
  );
}
export function FreeplayIcon(props: SvgIconProps) {
  const { color, ...reset } = props;
  return (
    <SvgIcon {...reset} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h34.84v34.84H0z" />
        <rect
          width="29.033"
          height="17.42"
          x="2.903"
          y="8.71"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.211"
          rx="4.913"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.211"
          d="M8.71 17.42h5.807m-2.904-2.903v5.806M21.775 15.968v.015M26.13 18.872v.014"
        />
      </g>
    </SvgIcon>
  );
}
export function ClassRoom(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 480 480"
    >
      <path d="M472.004 0H8a7.998 7.998 0 0 0-8 7.996V168h16V16h448v176H184v16h288a7.998 7.998 0 0 0 8-7.996V8a7.998 7.998 0 0 0-7.996-8z" />
      <path d="M264 40h160v16H264zM288 88h160v16H288zM256 136h160v16H256zM255.362 68.974c-5.477-13.165-20.589-19.397-33.753-13.92-.225.094-.449.19-.671.29l-64.868 33.65A39.559 39.559 0 0 0 160 72c0-22.091-17.909-40-40-40S80 49.909 80 72a39.604 39.604 0 0 0 8.205 24h-.333c-22.708.152-42.979 14.269-50.996 35.516L15.52 205.125c-5.084 13.206 1.5 28.034 14.707 33.118a25.626 25.626 0 0 0 18.692-.11 25.838 25.838 0 0 0 14.715-15.383L72 196.125v115.783a39.617 39.617 0 0 0-24-8.205c-22.058-.033-39.967 17.822-40 39.881a39.939 39.939 0 0 0 12.087 28.685A36.855 36.855 0 0 0 0 404.961V472a7.998 7.998 0 0 0 7.996 8H88a7.998 7.998 0 0 0 8-7.996v-67.043A36.77 36.77 0 0 0 81.724 376h60.553a36.764 36.764 0 0 0-14.276 28.961V472a7.998 7.998 0 0 0 7.996 8h80.004a7.998 7.998 0 0 0 8-7.996v-67.043a36.855 36.855 0 0 0-20.087-32.692c15.795-15.417 16.102-40.72.685-56.515a39.966 39.966 0 0 0-36.598-11.242V140.859l73.441-38.133c13.164-5.476 19.396-20.588 13.92-33.752zM120 48c13.255 0 24 10.745 24 24s-10.745 24-24 24c-13.249-.014-23.986-10.751-24-24 0-13.255 10.745-24 24-24zM48 319.703c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24c.014-13.249 10.751-23.985 24-24zM80 464H16v-59.039c.016-11.571 9.393-20.947 20.965-20.961h22.07c11.571.014 20.949 9.39 20.965 20.961V464zm128-59.039V464h-64v-59.039c.016-11.571 9.393-20.947 20.965-20.961h22.07c11.572.014 20.949 9.39 20.965 20.961zm-32-85.258c13.249.014 23.986 10.751 24 24 0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24zM240.723 82.32a10.29 10.29 0 0 1-6.039 5.922l-78.367 40.656A8.002 8.002 0 0 0 152 136v175.908c-14.985 11.08-20.176 31.133-12.448 48.092H128V224h-16v136H84.448a39.63 39.63 0 0 0 3.522-16H88V144a8 8 0 0 0-15.632-2.398L48.48 217.617c-1.81 4.992-7.325 7.572-12.317 5.761a9.677 9.677 0 0 1-1.027-.441 9.82 9.82 0 0 1-4.468-12.703l21.355-73.609A38.65 38.65 0 0 1 87.871 112h56.645a7.968 7.968 0 0 0 3.684-.898l79.512-41.273a9.848 9.848 0 0 1 12.59 4.664 9.733 9.733 0 0 1 .421 7.827zM331.913 372.269c15.823-15.416 16.153-40.741.737-56.564-15.416-15.823-40.741-16.153-56.564-.737-15.823 15.416-16.153 40.741-.737 56.564.243.249.489.495.738.737A36.857 36.857 0 0 0 256 404.961V472a7.998 7.998 0 0 0 7.996 8H344a7.998 7.998 0 0 0 8-7.996v-67.043a36.855 36.855 0 0 0-20.087-32.692zM304 319.703c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24c.014-13.249 10.751-23.985 24-24zM336 464h-64v-59.039c.016-11.571 9.393-20.947 20.965-20.961h22.07c11.571.014 20.949 9.39 20.965 20.961V464zM459.913 372.269c15.823-15.416 16.153-40.741.737-56.564-15.416-15.823-40.741-16.153-56.564-.737-15.823 15.416-16.153 40.741-.737 56.564.243.249.489.495.738.737A36.857 36.857 0 0 0 384 404.961V472a7.998 7.998 0 0 0 7.996 8H472a7.998 7.998 0 0 0 8-7.996v-67.043a36.855 36.855 0 0 0-20.087-32.692zM432 319.703c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24c.014-13.249 10.751-23.985 24-24zM464 464h-64v-59.039c.016-11.571 9.393-20.947 20.965-20.961h22.07c11.571.014 20.949 9.39 20.965 20.961V464z" />
    </SvgIcon>
  );
}
export function ErrorIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h17.6v17.6H0z" />
        <circle cx="8.8" cy="8.8" r="6.6" fill="#F54F64" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.1"
          d="M8.8 5.867V8.8M8.8 11.733h.007"
        />
      </g>
    </SvgIcon>
  );
}
export function CopyIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 31"
      style={{ width: "20px", cursor: "pointer" }}
    >
      <defs>
        <filter id="a" colorInterpolationFilters="auto">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(-412 -399)"
      >
        <g transform="translate(412 399)">
          <path d="M0 0h31v31H0z" />
          <rect
            width="15.5"
            height="15.5"
            x="10.333"
            y="10.333"
            stroke="#2C3E50"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.925"
            rx="2.567"
          />
          <path
            stroke="#2C3E50"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.925"
            d="M20.667 10.333V7.75a2.583 2.583 0 0 0-2.584-2.583H7.75A2.583 2.583 0 0 0 5.167 7.75v10.333a2.583 2.583 0 0 0 2.583 2.584h2.583"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function ArrowDropDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 9">
      <path
        d="M7.255 10.36l6.19-9.354a.336.336 0 00.02-.333A.308.308 0 0013.19.5H.81a.308.308 0 00-.275.173.336.336 0 00.02.333l6.19 9.355c.058.087.153.139.255.139a.307.307 0 00.255-.14z"
        fill="#62C3EE"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
}
export function ClearIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14">
      <path
        fill="#D44E4E"
        fillRule="nonzero"
        d="M.216 11.678L2.3 13.763a.737.737 0 0 0 1.042 0l3.647-3.648 3.647 3.648a.737.737 0 0 0 1.042 0l2.085-2.085a.737.737 0 0 0 0-1.042L10.115 6.99l3.648-3.647a.737.737 0 0 0 0-1.042L11.678.216a.737.737 0 0 0-1.042 0L6.99 3.863 3.342.216a.737.737 0 0 0-1.042 0L.216 2.3a.737.737 0 0 0 0 1.042l3.647 3.647-3.647 3.647a.737.737 0 0 0 0 1.042z"
      />
    </SvgIcon>
  );
}
export function AlertIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40">
      <defs>
        <filter
          id="a"
          width="106.3%"
          height="124.5%"
          x="-3.1%"
          y="-12.2%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g
        fill="#F54F64"
        fillRule="nonzero"
        filter="url(#a)"
        transform="translate(-330 -3)"
      >
        <path d="M363.57 30.323l-10.001-17.115A2.426 2.426 0 0 0 351.45 12c-.884 0-1.676.452-2.118 1.208l-10.001 17.115a2.366 2.366 0 0 0 0 2.416 2.426 2.426 0 0 0 2.117 1.208h20.003c.884 0 1.676-.451 2.118-1.208a2.367 2.367 0 0 0 0-2.416zm-12.12.84a1.584 1.584 0 0 1-1.591-1.573c0-.867.714-1.572 1.592-1.572.878 0 1.592.705 1.592 1.572 0 .867-.715 1.573-1.592 1.573zm1.603-6.723c0 .873-.719 1.584-1.602 1.584-.884 0-1.603-.71-1.603-1.584v-7.266c0-.415.34-.75.76-.75h1.686c.42 0 .76.335.76.75v7.266z" />
      </g>
    </SvgIcon>
  );
}
export function SuccessIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41">
      <defs>
        <filter
          id="a"
          width="106.3%"
          height="124.5%"
          x="-3.1%"
          y="-12.2%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g
        fill="#6DC679"
        fillRule="nonzero"
        filter="url(#a)"
        transform="translate(-331 -5)"
      >
        <path d="M351.48 14C345.15 14 340 19.15 340 25.48s5.15 11.48 11.48 11.48 11.48-5.15 11.48-11.48S357.81 14 351.48 14zm6.592 9.54l-7.212 7.213a1.613 1.613 0 0 1-1.148.476c-.434 0-.842-.17-1.148-.476l-3.676-3.676a1.613 1.613 0 0 1-.476-1.148c0-.433.17-.841.476-1.148a1.612 1.612 0 0 1 1.148-.475c.434 0 .841.169 1.148.475l2.528 2.528 6.064-6.064a1.613 1.613 0 0 1 1.148-.476 1.625 1.625 0 0 1 1.148 2.771z" />
      </g>
    </SvgIcon>
  );
}
export function AddIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path
        fill="#62C3EE"
        fillRule="evenodd"
        d="M4.798 9.197v.366c0 1.025-.004 2.05.001 3.075.005.883.477 1.35 1.363 1.356.537.003 1.074.001 1.61 0 .96-.002 1.424-.461 1.426-1.415V9.534c0-.104.01-.208.016-.337h.341c1.035 0 2.07.004 3.104-.001.845-.005 1.323-.482 1.332-1.327.006-.566.003-1.132 0-1.698-.004-.91-.462-1.37-1.368-1.371-1.025-.003-2.05 0-3.075-.001h-.35v-.35c0-1.034.004-2.069-.001-3.103C9.192.476 8.72.006 7.857.002 7.301-.001 6.744 0 6.188.002c-.927.001-1.386.455-1.39 1.38-.002 1.024 0 2.05 0 3.074V4.8h-.355c-1.035 0-2.07-.003-3.104.001-.869.004-1.33.47-1.335 1.343C0 6.729-.003 7.314.004 7.9c.011.808.49 1.288 1.303 1.295.937.008 1.874.002 2.811.002h.68"
      />
    </SvgIcon>
  );
}
export function PrintWorkSheetIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
      <path
        fill="#62C3EE"
        fillRule="nonzero"
        d="M19.906 14.701c.389 0 .703.315.703.703v7.5c0 .905-.736 1.64-1.64 1.64H6.03c-.904 0-1.64-.735-1.64-1.64v-7.5c0-.388.314-.703.703-.703zm-2.718 5.625H7.813a.703.703 0 1 0 0 1.406h9.375a.703.703 0 1 0 0-1.406zm5.671-13.078c.905 0 1.641.736 1.641 1.64v10.126c0 .904-.736 1.64-1.64 1.64h-.844v-5.25c0-1.163-.947-2.11-2.11-2.11H5.094c-1.163 0-2.11.947-2.11 2.11v5.25h-.843c-.905 0-1.641-.736-1.641-1.64V8.889c0-.905.736-1.641 1.64-1.641zm-5.672 10.266H7.813a.703.703 0 1 0 0 1.406h9.375a.703.703 0 1 0 0-1.406zm3.563-7.22a.703.703 0 1 0 0 1.407.703.703 0 0 0 0-1.406zM18.969.545c.906 0 1.64.735 1.64 1.641v3.657H4.391V2.185c0-.906.734-1.64 1.64-1.64H18.97z"
      />
    </SvgIcon>
  );
}
export function LanguageFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19">
      <path
        // fill="#C5C5C5"
        fillRule="nonzero"
        d="M21.186 9.112c.226.685.404 1.329.533 1.932.13.603.194 1.231.194 1.883 0 1.5-.396 2.723-1.188 3.669-.792.946-1.932 1.418-3.419 1.418a4.254 4.254 0 0 1-1.673-.318c-.501-.212-.897-.497-1.188-.856a3.253 3.253 0 0 1-1.382.954 5.141 5.141 0 0 1-1.819.318c-1.584 0-2.724-.407-3.419-1.223-.695-.815-1.042-1.858-1.042-3.13 0-.326.04-.783.12-1.37.082-.587.187-1.092.316-1.516l3.298-.098a11.31 11.31 0 0 0-.194 2.103c0 .587.097 1.02.29 1.297.195.277.486.415.874.415.323 0 .573-.097.751-.293.178-.196.316-.554.413-1.076.096-.522.145-1.256.145-2.201l3.152-.196c-.032.652-.048 1.32-.048 2.006 0 1.076.42 1.614 1.26 1.614.453 0 .76-.147.922-.44.162-.294.242-.734.242-1.321a7.44 7.44 0 0 0-.145-1.394c-.097-.506-.21-.987-.34-1.443l3.347-.734zm-14.837-9c.55 0 1.058.143 1.52.43.464.286.834.672 1.11 1.157.275.486.412 1.027.412 1.625 0 .946-.288 1.774-.864 2.483-.576.71-1.515 1.338-2.817 1.886-1.302.548-3.03 1.02-5.184 1.42L0 6.796c1.603-.274 2.993-.598 4.17-.971-.426-.349-.733-.71-.92-1.083-.188-.374-.282-.834-.282-1.382 0-.523.15-1.033.45-1.531.301-.498.708-.909 1.221-1.232A3.14 3.14 0 0 1 6.35.112zM24 1.7v2.647l-9.391 1.589V3.324L24 1.7zm-17.877.802c-.225 0-.432.1-.62.299a.955.955 0 0 0-.281.672c0 .224.081.43.244.616.163.187.457.405.883.654.45-.374.676-.772.676-1.195 0-.274-.088-.517-.263-.728-.176-.212-.388-.318-.639-.318z"
      />
    </SvgIcon>
  );
}
export function ReadingFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 20">
      <path
        // fill="#FFF"
        fillRule="nonzero"
        d="M24.1 3.279c.496 0 .9.397.9.885v14.063c0 .271-.123.523-.339.692a.911.911 0 0 1-.763.17c-2.158-.482-5.945-1.044-9.536-.18 2.076-1.931 5.009-2.273 6.787-2.277 1.267-.003 2.297-1.016 2.297-2.259V3.28zm-22.546 0v11.095c0 1.242 1.03 2.255 2.297 2.258 1.778.004 4.71.346 6.787 2.277-3.591-.864-7.378-.303-9.536.18a.91.91 0 0 1-.763-.17.874.874 0 0 1-.339-.692V4.164c0-.488.404-.885.9-.885h.654zM3.569.112c2.127.005 5.995.483 8.008 3.626a.828.828 0 0 1 .125.447v13.872c-2.452-2.489-6.008-2.918-8.13-2.923-.503 0-.912-.397-.912-.883V.996c0-.237.095-.46.268-.627a.913.913 0 0 1 .639-.257zm17.864 0c.241 0 .468.091.64.257.172.167.267.39.267.627v13.255c0 .486-.409.882-.912.883-2.122.005-5.678.434-8.13 2.923V4.185c0-.164.043-.32.125-.447C15.436.595 19.305.118 21.431.112z"
      />
    </SvgIcon>
  );
}
export function GamesFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 22">
      <path
        // fill="#A5AAB6"
        fillRule="nonzero"
        d="M19.055 3.912c-4.175-3.361-7.01 1.066-7.01 1.066a2.157 2.157 0 0 1-.915.734l-1.051.383c-.319.117-.846.128-1.171.027 0 0-5.019-1.57-6.057 3.689-1.038 5.257 1.72 9.567 1.72 9.567.603 1.082 1.488 1.628 2.597 1.115 1.107-.512 2.492-4.411 2.492-4.411.115-.322.47-.68.789-.795l6.304-2.296c.319-.116.82-.07 1.115.102 0 0 3.568 2.097 4.746 1.777 1.178-.32 1.507-1.309 1.272-2.523 0 0-.656-5.075-4.83-8.435zm-9.195 7.32l-1.352.491.478 1.312s-.207.324-.652.48c-.444.154-.73-.006-.73-.006l-.467-1.286-1.277.465s-.22-.107-.42-.524c-.2-.418-.109-.847-.109-.847l1.353-.492-.495-1.361s.223-.251.627-.385c.405-.134.754-.089.754-.089l.48 1.337 1.277-.465s.328.207.473.549c.145.341.06.82.06.82zm6.746-.763a1.14 1.14 0 0 1-1.462-.688 1.14 1.14 0 0 1 .678-1.466 1.143 1.143 0 0 1 1.462.687 1.143 1.143 0 0 1-.678 1.467zm-1.079-2.963a1.14 1.14 0 0 1-1.461-.688 1.14 1.14 0 0 1 .677-1.466 1.143 1.143 0 0 1 1.463.687 1.143 1.143 0 0 1-.679 1.467zm3.244.62a1.14 1.14 0 0 1-1.461-.687 1.14 1.14 0 0 1 .677-1.467 1.143 1.143 0 0 1 1.462.688 1.143 1.143 0 0 1-.678 1.467z"
      />
    </SvgIcon>
  );
}
export function WorkSheetFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 22">
      <path
        // fill="#A5AAB6"
        fillRule="nonzero"
        d="M16.625 3.612c1.31 0 2.375 1.079 2.375 2.406v12.688c0 1.327-1.065 2.406-2.375 2.406H6.693c-1.31 0-2.375-1.079-2.375-2.406V6.018c0-1.327 1.065-2.406 2.375-2.406zm-4.318-3.5c1.084 0 1.99.743 2.274 1.75H6.693c-2.262 0-4.102 1.865-4.102 4.156v12.47h-.216C1.065 18.487 0 17.407 0 16.08V2.518C0 1.191 1.065.112 2.375.112zm2.59 17.063H8.42a.652.652 0 0 0-.647.656c0 .362.29.656.647.656h6.478a.652.652 0 0 0 .647-.656.652.652 0 0 0-.647-.656zm0-3.5H8.42a.652.652 0 0 0-.647.656c0 .362.29.656.647.656h6.478a.652.652 0 0 0 .647-.656.652.652 0 0 0-.647-.656zm0-3.063H8.42a.652.652 0 0 0-.647.656c0 .363.29.657.647.657h6.478a.652.652 0 0 0 .647-.657.652.652 0 0 0-.647-.656zm0-3.5H8.42a.652.652 0 0 0-.647.656c0 .363.29.657.647.657h6.478a.652.652 0 0 0 .647-.657.652.652 0 0 0-.647-.656z"
      />
    </SvgIcon>
  );
}
export function ListeningFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 24">
      <g
        //  fill="#585858"
        fillRule="nonzero"
      >
        <path d="M21.828 3.58c3.235.304 5.772 3.234 5.772 6.657 0 2.121-.69 4.21-1.94 5.91l-.213.28-1.85 2.332c-.477.598-.838 1.344-1.07 2.059-.547 1.63-2.06 2.73-3.759 2.73-2.121 0-3.86-1.759-3.963-3.875l-.005-.2v-3.035l.102-.037.279.422a.655.655 0 0 0 .66.144.628.628 0 0 0 .429-.508l1.479-3.602c1.477-.82 2.649-1.868 3.385-3.062.395.32.648.814.648 1.368a1.75 1.75 0 0 1-1.602 1.753l-.144.005v1.173c1.606 0 2.91-1.313 2.91-2.93a2.934 2.934 0 0 0-1.289-2.434 5.322 5.322 0 0 0 .334-1.559c1.22.37 2.118 1.627 2.118 3.066a6.405 6.405 0 0 1-1.21 3.757l-.175.229-2.862 3.61.907.726 2.863-3.598a7.63 7.63 0 0 0 1.64-4.724c0-2.112-1.444-3.93-3.351-4.281-.148-.848-.503-1.656-1.03-2.4.306-.014.619-.007.937.023zm10.975 5.569a7.162 7.162 0 0 1 1.997 5 7.17 7.17 0 0 1-1.787 4.773l-.21.227-.803-.833a5.969 5.969 0 0 0 1.664-4.167c0-1.475-.52-2.868-1.468-3.954L32 9.982l.803-.833zm-1.9 1.6c.965.91 1.497 2.117 1.497 3.4a4.62 4.62 0 0 1-1.31 3.214l-.187.186-.903-.85c.724-.683 1.123-1.588 1.123-2.55 0-.888-.34-1.728-.962-2.388L30 11.599l.903-.85zm-1.63 2c.469.428.727.995.727 1.6 0 .544-.209 1.058-.592 1.468l-.134.132-.874-.801c.234-.213.363-.497.363-.8 0-.258-.095-.503-.27-.702l-.093-.096.874-.801zM16 6.499c0 .59-.34 1.1-.835 1.346a6.455 6.455 0 0 1 .814-1.581c.015.077.021.155.021.235z" />
        <path d="M12.832 13.194l2.155 2.107a.529.529 0 0 0 .898-.313l.395-3.092c2.141-1.237 3.504-3.083 3.504-5.147C19.784 3.02 15.354 0 9.892 0 4.429 0 0 3.021 0 6.749c0 3.725 4.429 6.747 9.892 6.747 1.023 0 2.011-.106 2.94-.302zm.82-7.75a1.304 1.304 0 1 1 .002 2.608 1.304 1.304 0 0 1-.003-2.608zM6.131 8.05a1.305 1.305 0 1 1-.001-2.61 1.305 1.305 0 0 1 0 2.61zm2.456-1.304A1.304 1.304 0 1 1 9.892 8.05a1.303 1.303 0 0 1-1.304-1.304z" />
      </g>
    </SvgIcon>
  );
}
export function VideosFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22">
      <path
        // fill="#A5AAB6"
        fillRule="nonzero"
        d="M26 10.131v8.636c0 1.287-1.067 2.345-2.364 2.345H3.488c-1.297 0-2.364-1.058-2.364-2.345v-8.636H26zm-14.412 2.23c-.346-.171-.75-.085-.952.258a.757.757 0 0 0-.086.343v5.348c0 .371.317.686.692.686a.666.666 0 0 0 .403-.114l2.277-1.316.03-.028 2.276-1.316c.346-.2.462-.6.26-.944a.563.563 0 0 0-.26-.257l-2.306-1.315zm-.433-6.52l3.546 3.518h-3.402L7.725 5.84h3.43zm-5.794 0L8.936 9.36H1.124v-1.03h.778a1.41 1.41 0 0 0 1.413-1.4V5.84H5.36zm11.56 0l3.545 3.518h-3.402L13.52 5.84h3.401zm9.079 0V9.36h-3.142L19.284 5.84H26zM1.902 4.068c.289 0 .548.23.548.544v2.316c0 .286-.23.543-.548.543H.548A.545.545 0 0 1 0 6.928V4.612c0-.286.23-.544.548-.544zm6.659-2.487l-3.2 3.86-2.046.2v-1.03c0-.8-.634-1.429-1.384-1.4h-.634c.346-.601.951-1.03 1.672-1.087l5.592-.543zm5.736-.572l-3.2 3.86-3.4.315 3.199-3.832 3.401-.343zm5.736-.544l-3.17 3.832-3.402.343 3.2-3.86 3.372-.315zm3.344-.343a2.182 2.182 0 0 1 2.364 1.945l.144 1.372-6.688.63 3.2-3.861z"
      />
    </SvgIcon>
  );
}
export function CharFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 28">
      <path
        // fill="#A5AAB6"
        fillRule="nonzero"
        d="M10.791 15.483c.493 0 .899.367.955.84l.006.11v9.729c0 .487-.37.889-.849.944l-.112.006H.961a.957.957 0 0 1-.955-.84L0 26.163v-9.728c0-.488.37-.89.849-.944l.112-.007h9.83zm4.904-2.572l.111.02 9.501 2.499a.95.95 0 0 1 .682 1.057l-.023.107-2.505 9.418-.036.106a.963.963 0 0 1-1.031.59l-.11-.023-9.5-2.499h-.001a.95.95 0 0 1-.703-1.055l.023-.109 2.526-9.397a.977.977 0 0 1 1.066-.714zM5.59 22.39l-.362.523.578.4.356-.533-.572-.39zm13.378-4.737c-.12.001-.227.016-.32.044l-.363.499.02.032c.114-.012.245-.012.392-.001a1.981 1.981 0 0 1 .744.185c.125.057.277.137.455.24-.338.063-.66.166-.967.31a2.713 2.713 0 0 0-.787.546c-.219.22-.362.47-.431.745-.072.287-.053.553.054.798.108.245.292.458.553.639.261.18.582.318.962.413.224.056.435.085.635.09.199.003.371-.019.517-.067l.328-.49-.024-.04c-.191.011-.381.01-.568-.006a3.273 3.273 0 0 1-.522-.084c-.478-.119-.83-.288-1.053-.507a.761.761 0 0 1-.224-.774c.067-.27.232-.497.496-.683.263-.185.59-.308.982-.368.391-.06.804-.047 1.239.039l.313-.588a4.416 4.416 0 0 1-.662-.22 5.596 5.596 0 0 1-.708-.375l-.033-.02c-.15-.09-.277-.158-.38-.206a1.366 1.366 0 0 0-.647-.15zM7.576 19.886h-.065l-.55.438c.198.42.291.719.28.897-.097.028-.24.053-.429.073l-.064.007a7.286 7.286 0 0 1-.7.032h-.296c-.367 0-.657-.02-.87-.062-.212-.04-.368-.11-.47-.21-.1-.1-.15-.24-.15-.422 0-.132.016-.28.048-.443l-.054-.027-.48.181a2.756 2.756 0 0 0-.073.326 2.1 2.1 0 0 0-.024.326c0 .324.157.571.472.742.315.17.771.256 1.369.256h.329c.352 0 .667-.02.944-.061.278-.041.48-.099.605-.174a.805.805 0 0 0 .316-.355 1.1 1.1 0 0 0 .11-.478c0-.128-.02-.284-.062-.47a3.5 3.5 0 0 0-.186-.576zm12.069.019l-.478.42.463.533.476-.437-.461-.516zM16.008.603l.052.107 3.595 9.076a.946.946 0 0 1-.438 1.187l-.102.047-9.15 3.556a.966.966 0 0 1-1.2-.433l-.047-.101-3.622-9.077a.946.946 0 0 1 .438-1.186l.102-.047L14.813.176a.977.977 0 0 1 1.195.427zm-3.698 5.13l-.518.387 1.326 3.282.052.014.528-.352-1.326-3.322-.062-.01zm-.342-1.325a1.155 1.155 0 0 0-.403.07.481.481 0 0 0-.28.25.448.448 0 0 0 .007.356.5.5 0 0 0 .095.149c.042.046.089.086.14.118a3.257 3.257 0 0 1-.142.063l-.085.035.179.343c.351-.156.645-.299.882-.427l.066-.037-.163-.331c-.062.033-.154.08-.276.14l-.13.064a.287.287 0 0 1-.183-.162.163.163 0 0 1-.002-.135.19.19 0 0 1 .108-.093.751.751 0 0 1 .231-.047z"
      />
    </SvgIcon>
  );
}
export function WritingFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
      <path
        // fill="#C5C5C5"
        fillRule="nonzero"
        d="M16.862 20.691c.481 0 .829.535.569.937-.099.151-.197.303-.298.452-.186.281.054.641.399.6l6.722-.83a.811.811 0 0 1 .112-.008c.304 0 .544.172.616.436a.602.602 0 0 1-.09.488.56.56 0 0 1-.384.242h-.005l-9.064 1.102c-.022.002-.04.002-.057.002a.573.573 0 0 1-.405-.167c-.22-.211-.263-.62-.074-.866l.205-.269c.21-.282-.035-.668-.394-.616L4.214 23.7a.6.6 0 0 1-.706-.548c-.027-.316.192-.58.517-.626l2.873-.413 1.053-.15 8.81-1.264a.689.689 0 0 1 .1-.008zM1.115 17.696l4.358 3.33c-.222.114-.419.192-.416.192L.608 23.15c-.32.141-.67-.128-.599-.456l.999-4.561s.035-.204.107-.436zm12.33-14.959l4.623 3.536-.003.002.849.647.495-.59a.927.927 0 0 1 1.234-.159.815.815 0 0 1 .155 1.195l-5.074 6.054a.911.911 0 0 1-1.24.13.835.835 0 0 1-.325-.563.808.808 0 0 1 .189-.619l3.468-4.135-.848-.647L6.241 20.373 1.615 16.84l11.83-14.103zm1.318-1.573c1.013-1.208 2.86-1.404 4.123-.439l.047.037c1.266.965 1.472 2.727.46 3.932l-.74.882-4.626-3.533z"
      />
    </SvgIcon>
  );
}
export function ActivitiesFilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 26">
      <g fillRule="evenodd" transform="translate(1 .112)">
        <path
          fillRule="nonzero"
          d="M16.603 7.73c.394.144.8.206 1.217.184a2.515 2.515 0 0 0 1.143-.33c.11.316.312.615.607.9.295.283.65.501 1.067.655.789.29 1.496.237 2.123-.158.626-.395 1.086-1.002 1.38-1.82.112-.31.2-.709.264-1.198.065-.49.1-.946.103-1.37l-1.721-.183c.02.358.005.728-.046 1.11-.05.381-.132.727-.243 1.037-.294.817-.76 1.11-1.395.876-.35-.13-.594-.332-.73-.607-.137-.276-.13-.624.021-1.044.183-.508.35-.935.499-1.28l-1.548-.458c-.364.943-.705 1.562-1.023 1.858-.317.296-.673.372-1.068.227-.635-.234-.802-.771-.5-1.61.12-.332.342-.776.666-1.333l-1.569-.502c-.398.554-.68 1.064-.847 1.528-.263.73-.292 1.413-.088 2.052.205.638.767 1.127 1.688 1.465z"
        />
        <g transform="rotate(-24 33.816 -39.553)">
          <rect width="1" height="1.519" x=".151" rx=".305" />
          <rect width="1" height="1.519" x=".292" y="2.262" rx=".305" />
          <rect width="1" height="1.519" x=".146" y="4.986" rx=".305" />
          <rect width="1" height="1.519" y="7.711" rx=".305" />
        </g>
        <ellipse cx="15.404" cy="19.653" rx="5.288" ry="5.347" />
        <path d="M6.211 2.286l10.055 8.39-12.422 4.572z" />
      </g>
    </SvgIcon>
  );
}
